export default "__VITE_ASSET__DmWeZFhn__"